/*
 * Version: 2.0.20
 * Build time: Tue Jan 17 2017 11:09:52 GMT+0800 (CST)
 * Copyright 2016, Alibaba
 */

!
function(t) {
	function e(o) {
		if (i[o]) return i[o].exports;
		var s = i[o] = {
			exports: {},
			id: o,
			loaded: !1
		};
		return t[o].call(s.exports, s, s.exports, e), s.loaded = !0, s.exports
	}
	var i = {};
	return e.m = t, e.c = i, e.p = "", e(0)
}([function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	var s = i(1),
		r = o(s);
	window.FocusEngine || (window.FocusEngine = r["default"])
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var s = i(2),
		r = o(s),
		n = i(3),
		h = o(n),
		a = i(4),
		l = o(a),
		d = i(5),
		c = o(d),
		f = i(8),
		u = o(f),
		g = i(9),
		p = o(g),
		y = {
			Event: r["default"],
			Widget: h["default"],
			Switch: l["default"],
			Scroll: c["default"],
			Grid: u["default"],
			Grille: p["default"],
			roles: ["Widget", "Switch", "Scroll", "Grid", "Grille"],
			render: function(t, e) {
				void 0 === t && (t = document.body);
				var i = t.getAttribute("data-role");
				if (i && -1 === this.roles.indexOf(i)) return console.error(t), void console.error("[FocusEngine_Error](" + i + ")不是支持的data-role类型，只支持以下类型：" + this.roles.join("、"));
				if (i || t.setAttribute("data-role", "Widget"), window.$FocusEngineGlobalRoot) return window.$FocusEngineGlobalRoot.reRender(), window.$FocusEngineGlobalRoot.getWidgetById(t.id);
				var o = document.body.getAttribute("data-role");
				return o && -1 === this.roles.indexOf(o) ? void console.error("[FocusEngine_Error](" + o + ")不是支持的data-role类型，只支持以下类型：" + this.roles.join("、")) : (o || (document.body.setAttribute("data-role", "Widget"), o = "Widget"), window.$FocusEngineGlobalRoot = new this[o](document.body), window.$FocusEngineGlobalRoot.focus(), window.$FocusEngineGlobalRoot.handleRootEvent(e), window.$FocusEngineGlobalRoot.getWidgetById(t.id))
			},
			createWidget: function(t) {
				var e = t.getAttribute("data-role");
				return e && -1 === this.roles.indexOf(e) ? (console.error(t), void console.error("[FocusEngine_Error](" + e + ")不是支持的data-role类型，只支持以下类型：" + this.roles.join("、"))) : (e || t.setAttribute("data-role", "Widget"), new this[e](t))
			},
			appendWidget: function(t) {
				for (var e = this.createWidget(t); t.parentNode;) if (t = t.parentNode, t.getAttribute("data-role")) {
					var i = t.id;
					return void this.getWidgetById(i).addChildWidget(e)
				}
			},
			getRoot: function() {
				return window.$FocusEngineGlobalRoot
			},
			getWidgetById: function(t) {
				return window.$FocusEngineGlobalRoot ? window.$FocusEngineGlobalRoot.getWidgetById(t) : null
			},
			getFocusedLeaf: function() {
				return window.$FocusEngineGlobalRoot ? window.$FocusEngineGlobalRoot.getFocusedLeaf() : null
			},
			freeze: function(t) {
				window.$FocusEngineGlobalRoot && window.$FocusEngineGlobalRoot.freeze(t)
			},
			activate: function() {
				window.$FocusEngineGlobalRoot && window.$FocusEngineGlobalRoot.activate()
			},
			disableClick: function() {
				window.$FocusEngineGlobalRoot && window.$FocusEngineGlobalRoot.disableClick()
			},
			enableClick: function() {
				window.$FocusEngineGlobalRoot && window.$FocusEngineGlobalRoot.enableClick()
			}
		};
	e["default"] = y, t.exports = e["default"]
}, function(t, e) {
	"use strict";

	function i(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var o = function() {
			function t(t, e) {
				for (var i = 0; i < e.length; i++) {
					var o = e[i];
					o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
				}
			}
			return function(e, i, o) {
				return i && t(e.prototype, i), o && t(e, o), e
			}
		}(),
		s = function() {
			function t(e, o, s) {
				if (i(this, t), this.type = e, this._propagationStopped = !1, this._defaultPrevented = !1, this._listenerPrevented = !1, o && (this.target = o), s) for (var r in s) this[r] = s[r]
			}
			return t.prototype.stopPropagation = function() {
				this._propagationStopped = !0
			}, t.prototype.isPropagationStopped = function() {
				return this._propagationStopped
			}, t.prototype.preventDefault = function() {
				this._defaultPrevented = !0
			}, t.prototype.isDefaultPrevented = function() {
				return this._defaultPrevented
			}, t.prototype.preventListener = function() {
				this._listenerPrevented = !0
			}, t.prototype.isListenerPrevented = function() {
				return this._listenerPrevented
			}, o(t, null, [{
				key: "VK_ENTER",
				get: function() {
					return 13
				}
			}, {
				key: "VK_LEFT",
				get: function() {
					return 37
				}
			}, {
				key: "VK_UP",
				get: function() {
					return 38
				}
			}, {
				key: "VK_RIGHT",
				get: function() {
					return 39
				}
			}, {
				key: "VK_DOWN",
				get: function() {
					return 40
				}
			}]), t
		}();
	e["default"] = s, t.exports = e["default"]
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var r = i(2),
		n = o(r),
		h = i(1),
		a = o(h),
		l = function() {
			function t(e) {
				if (s(this, t), !e) return void console.error("[FocusEngine_Error]创建组件必须传入相应的容器元素。");
				if (this.con = e, this.con.id) this.id = this.con.id, document.querySelector("#" + this.id) !== this.con && console.error("[FocusEngine_Error]页面元素有重复的id(" + this.id + ")，请检查！");
				else {
					for (var i = Math.random().toString().slice(2, 12), o = !1; !o;) document.getElementById("fe-" + i) ? i = Math.random().toString().slice(2, 12) : o = !0;
					this.id = "fe-" + i, this.con.id = this.id
				}
				this.options = this._getOptions(e), this.parentWidget = null, this.focusedChildWidget = null, this.cachedChildWidget = null, this.active = !0, this.disabled = "yes" === this.options.cfg.disable, this.noClick = "yes" === this.options.cfg.disable_click, this.disabled && this.addClass("data-disable"), this.eventListeners = [], this._initChildWidgets()
			}
			return t.prototype.reRender = function() {
				document.querySelector("#" + this.id) && (this.con = document.querySelector("#" + this.id), this.options = this._getOptions(this.con), this._reRenderChildWidget())
			}, t.prototype.getFutureRect = function() {
				for (var t = this, e = t.getWidgetRect(); t.getParentWidget();) {
					var i = t.getParentWidget();
					i instanceof a["default"].Scroll && ("v" === i.dir ? (e.top += i.futureOffset, e.bottom += i.futureOffset, e.centerY += i.futureOffset) : "h" === i.dir && (e.left += i.futureOffset, e.right += i.futureOffset, e.centerX += i.futureOffset)), i instanceof a["default"].Grid && (i.horizontal ? (e.left += t.futureOffset, e.right += t.futureOffset, e.centerX += t.futureOffset) : (e.top += t.futureOffset, e.bottom += t.futureOffset, e.centerY += t.futureOffset)), t = i
				}
				return e
			}, t.prototype._reRenderChildWidget = function() {
				for (var t = Array.prototype.slice.call(this.con.querySelectorAll("[data-role]")), e = 0; e < t.length; e++) {
					var i = t[e],
						o = i.getAttribute("data-role"); - 1 !== a["default"].roles.indexOf(o) ? t = this._filterArray(t, Array.prototype.slice.call(t[e].querySelectorAll("[data-role]"))) : (console.error(i), console.error("[FocusEngine_Error](" + o + ")不是支持的data-role类型，只支持以下类型：" + a["default"].roles.join("、")))
				}
				for (var e = 0; e < this.childWidgets.length; e++) if (-1 !== t.indexOf(this.childWidgets[e].getDOMNode())) {
					var s = this.childWidgets[e].getDOMNode().getAttribute("data-role"); - 1 !== a["default"].roles.indexOf(s) && this.childWidgets[e] instanceof a["default"][s] || (this.removeChildWidget(e), e--)
				} else this.removeChildWidget(e), e--;
				for (var e = 0; e < this.childWidgets.length; e++) this.childWidgets[e].reRender();
				for (var e = 0; e < t.length && t.length > this.childWidgets.length; e++) {
					for (var r = t[e], n = !1, h = 0; h < this.childWidgets.length; h++) {
						var l = this.childWidgets[h];
						l.getDOMNode() === r && (n = !0)
					}
					if (!n) {
						var o = r.getAttribute("data-role");
						if (-1 !== a["default"].roles.indexOf(o)) {
							var d = new a["default"][o](r);
							this.addChildWidget(d, e)
						}
					}
				}
				this.focused && this.focus(!0, !0)
			}, t.prototype.getRoot = function() {
				return window.$FocusEngineGlobalRoot
			}, t.prototype.freeze = function(t) {
				var e = this.getRoot();
				return e ? (e.active = !1, t && (e.focusedLeafBeforeFreeze = e.getFocusedLeaf(), e.blur()), this) : this
			}, t.prototype.activate = function() {
				var t = this.getRoot();
				return t ? (t.active = !0, t.focusedLeafBeforeFreeze && (document.querySelector("#" + t.focusedLeafBeforeFreeze.id) === t.focusedLeafBeforeFreeze.getDOMNode() ? t.focusedLeafBeforeFreeze.focus() : t.focus(), t.focusedLeafBeforeFreeze = null), this) : this
			}, t.prototype.disable = function() {
				return this.disabled = !0, this.addClass("data-disable"), this
			}, t.prototype.enable = function() {
				return this.disabled = !1, this.removeClass("data-disable"), this
			}, t.prototype._getOptions = function(t) {
				var e = {};
				this.feCfg = this._removeSpaces(t.getAttribute("data-cfg"));
				var i = {};
				if (this.feCfg) {
					var o = this.feCfg.split(/,|;/);
					o.forEach(function(t) {
						var e = t.split(":");
						return e.length < 2 ? !1 : (e[0] = e[0].replace(/switch_|scroll_|grid_/g, ""), void(i[e[0]] = e[1]))
					})
				}
				e.cfg = i;
				var s = this._removeSpaces(t.getAttribute("data-goto")),
					r = {};
				if (s) {
					var n = s.split(";");
					n[0] && (r.up = n[0]), n[1] && (r.right = n[1]), n[2] && (r.down = n[2]), n[3] && (r.left = n[3])
				}
				return e.dir = r, e.tab = this._removeSpaces(t.getAttribute("data-index")), e
			}, t.prototype._initChildWidgets = function() {
				this.childWidgets = [], this.childMap = {};
				for (var t = Array.prototype.slice.call(this.con.querySelectorAll("[data-role]")), e = 0; e < t.length; e++) {
					var i = t[e],
						o = i.getAttribute("data-role"); - 1 !== a["default"].roles.indexOf(o) ? t = this._filterArray(t, Array.prototype.slice.call(t[e].querySelectorAll("[data-role]"))) : (console.error(i), console.error("[FocusEngine_Error](" + o + ")不是支持的data-role类型，只支持以下类型：" + a["default"].roles.join("、")))
				}
				for (var s = void 0, r = void 0, e = 0, n = t.length; n > e; e++) {
					s = t[e];
					var o = s.getAttribute("data-role"); - 1 !== a["default"].roles.indexOf(o) && (r = new a["default"][o](s), this.addChildWidget(r))
				}
			}, t.prototype.handleRootEvent = function(t) {
				var e = this;
				document.addEventListener("keydown", function(i) {
					if (e.active) {
						i = i || window.event;
						var o = i.keyCode,
							s = e.getFocusedLeaf();
						o && (s.fire(new n["default"]("keydown", s, {
							keyCode: o
						})), s && o === n["default"].VK_ENTER && s.fire(new n["default"]("okdown", s, {
							keyCode: o
						})), t || i.preventDefault())
					}
				}), document.addEventListener("keyup", function(i) {
					if (e.active) {
						i = i || window.event;
						var o = i.keyCode,
							s = e.getFocusedLeaf();
						o && (s && s.fire(new n["default"]("keyup", s, {
							keyCode: o
						})), s && o === n["default"].VK_ENTER && s.fire(new n["default"]("ok", s, {
							keyCode: o
						})), t || i.preventDefault())
					}
				}), document.addEventListener("click", function(i) {
					if (e.active) {
						i = i || window.event;
						for (var o = i.target, s = null; o && o !== document;) {
							if (-1 !== a["default"].roles.indexOf(o.getAttribute("data-role"))) {
								if (s = e.getWidgetById(o.id), s && s.isLeafWidget()) {
									for (var r = s; r;) {
										if (r.noClick) return;
										r = r.parentWidget
									}
									return s && s.fire(new n["default"]("click", s)), t || i.preventDefault(), void(s.disabled || (s.focused ? s.fire(new n["default"]("ok", s, {
										isClick: !0
									})) : s.focus()))
								}
								return
							}
							o = o.parentNode
						}
					}
				})
			}, t.prototype.getFocusedLeaf = function() {
				return this.isLeafWidget() ? this : this.getFocusedChildWidget() ? this.getFocusedChildWidget().getFocusedLeaf() : null
			}, t.prototype.addClass = function(t) {
				this.con.classList.add(t)
			}, t.prototype.removeClass = function(t) {
				this.con.classList.remove(t)
			}, t.prototype.hasClass = function(t) {
				return this.con.classList.contains(t)
			}, t.prototype.show = function() {
				this.con.style.display = "block"
			}, t.prototype.hide = function() {
				this.con.style.display = "none"
			}, t.prototype.focus = function(t, e) {
				if (!t && this.focused) return this;
				for (var i = this; !i.isLeafWidget();) {
					var o = i.getCachedChildWidget();
					if (o && "yes" !== i.options.cfg.disable_child_cache) i = o;
					else {
						var s = i.getDefaultFocusedChildWidget();
						if (s) i = s;
						else {
							var r = i.getFirstFocusableChildWidget();
							if (!r) break;
							i = r
						}
					}
				}
				var h = new n["default"]("focus", i, {
					force: t
				});
				return e && h.preventListener(), i.fire(h), this
			}, t.prototype.focusDefault = function(t) {
				if (!this.focused || t.force) {
					var e = this.getParentWidget();
					if (e) {
						var i = e.getFocusedChildWidget();
						i && i !== this && (i.isLeafWidget() ? t.blurLeaf = i : i.getFocusedLeaf() && (t.blurLeaf = i.getFocusedLeaf()), i.blur()), e.setFocusedChildWidget(this)
					}
					this.addClass("fe-focus"), this.focused = !0, this.cache()
				}
			}, t.prototype.blur = function() {
				if (!this.focused) return this;
				var t = this.getParentWidget();
				t && t.setFocusedChildWidget(null), this.removeClass("fe-focus"), this.focused = !1;
				var e = this.getFocusedChildWidget();
				return e && e.blur(), this.fire(new n["default"]("blur", this)), this
			}, t.prototype.cache = function() {
				if (this.cached) return this;
				var t = this.getParentWidget();
				if (t) {
					var e = t.getCachedChildWidget();
					e && (e.removeClass("fe-cache"), e.cached = !1), t.setCachedChildWidget(this)
				}
				return this.addClass("fe-cache"), this.cached = !0, this
			}, t.prototype.isLeafWidget = function() {
				return !this.getFirstFocusableChildWidget()
			}, t.prototype.getParentWidget = function() {
				return this.parentWidget
			}, t.prototype.getFocusedChildWidget = function() {
				if (!this.focusedChildWidget) return null;
				if (-1 === this.childWidgets.indexOf(this.focusedChildWidget)) {
					var t = this.getWidgetById(this.focusedChildWidget.id);
					return -1 !== this.childWidgets.indexOf(t) ? t : null
				}
				return this.focusedChildWidget
			}, t.prototype.setFocusedChildWidget = function(t) {
				t && -1 === this.childWidgets.indexOf(t) || (this.focusedChildWidget = t)
			}, t.prototype.getCachedChildWidget = function() {
				return this.cachedChildWidget ? -1 === this.childWidgets.indexOf(this.cachedChildWidget) ? null : this.cachedChildWidget.disabled ? null : this.cachedChildWidget : null
			}, t.prototype.setCachedChildWidget = function(t) {
				t && -1 === this.childWidgets.indexOf(t) || (this.cachedChildWidget = t)
			}, t.prototype.getDefaultFocusedChildWidget = function() {
				return this.defaultFocusedChildWidget ? -1 === this.childWidgets.indexOf(this.defaultFocusedChildWidget) ? null : this.defaultFocusedChildWidget.disabled ? null : this.defaultFocusedChildWidget : null
			}, t.prototype.getFirstFocusableChildWidget = function() {
				for (var t = 0; t < this.childWidgets.length; t++) {
					var e = this.childWidgets[t];
					if (!e.disabled) return e
				}
				return null
			}, t.prototype.setDefaultFocusedChildWidget = function(t) {
				t && -1 === this.childWidgets.indexOf(t) || (this.defaultFocusedChildWidget = t)
			}, t.prototype.getWidgetById = function(t) {
				if (this.id === t) return this;
				if (this.childMap[t]) return this.childMap[t];
				for (var e = 0, i = this.childWidgets.length; i > e; e++) {
					var o = this.childWidgets[e].getWidgetById(t);
					if (o) return o
				}
				return null
			}, t.prototype.addChildWidget = function(t, e) {
				e || 0 === e || (e = this.childWidgets.length), this.childWidgets.splice(e, 0, t), this.childMap[t.id] = t, t.parentWidget = this, "yes" === t.options.cfg.default_focus && this.setDefaultFocusedChildWidget(t)
			}, t.prototype.hasChildWidget = function(t) {
				return -1 !== this.childWidgets.indexOf(t)
			}, t.prototype.removeChildWidget = function(e) {
				var i = void 0;
				if (e instanceof t && (e = this.childWidgets.indexOf(e)), !(0 > e)) {
					i = this.childWidgets.splice(e, 1);
					var o = i.length ? i[0] : null;
					if (o) {
						if (delete this.childMap[o.id], o === this.getFocusedChildWidget()) {
							var s = this.getDefaultFocusedChildWidget() === o ? this.childWidgets[0] : this.getDefaultFocusedChildWidget();
							s.focus()
						}
						return o === this.getCachedChildWidget() && (this.cachedChildWidget = null), o
					}
				}
			}, t.prototype.getDOMNode = function() {
				return this.con
			}, t.prototype.getWidgetRect = function(t) {
				if (t && this.rect) return this.rect;
				var e = this.getDOMNode(),
					i = e.getBoundingClientRect(),
					sTop = !document.getElementById('scroll-list') ? 0 : document.getElementById('scroll-list').scrollTop;
				return this.rect = {
					top: i.top + sTop,
					bottom: i.bottom + sTop,
					right: i.right,
					left: i.left,
					width: i.width,
					height: i.height,
					centerX: i.width / 2 + i.left,
					centerY: i.height / 2 + i.top
				}, this.rect
			}, t.prototype.getWidgetRectAsync = function(t) {
				var e = this;
				window.requestAnimationFrame(function() {
					var i = e.getDOMNode(),
						o = i.getBoundingClientRect(),
						sTop = !document.getElementById('scroll-list') ? 0 : document.getElementById('scroll-list').scrollTop,
						s = {
							top: o.top + sTop,
							bottom: o.bottom + sTop,
							right: o.right,
							left: o.left,
							width: o.width,
							height: o.height,
							centerX: o.width / 2 + o.left,
							centerY: o.height / 2 + o.top
						};
					e.rect || (e.rect = s), t && t(s)
				})
			}, t.prototype.on = function(t, e, i, o) {
				return t.constructor !== String ? (console.warn("[FocusEngine] 事件type类型必须是String"), -1) : e.constructor !== Function ? (console.warn("[FocusEngine] 事件监听类型必须是Function"), -1) : (t = t.toLowerCase(), this.eventListeners.push({
					type: t,
					cb: e,
					ctx: i || null,
					after: !! o
				}), this.eventListeners.length - 1)
			}, t.prototype.off = function(t) {
				0 > t || (this.eventListeners[t] = null)
			}, t.prototype.detach = function(t, e) {
				console.warn("[FocusEngine] detach方法不再推荐使用，请使用off方法"), t = t.toLowerCase();
				for (var i = 0, o = this.eventListeners.length; o > i; i++) {
					var s = this.eventListeners[i];
					s.type === t && s.cb === e && (this.eventListeners[i] = null)
				}
			}, t.prototype.fire = function(t) {
				this.exeEventListeners(t), this.exeEventDefault(t), this.exeEventListeners(t, !0);
				for (var e = this; e.parentWidget && !t.isPropagationStopped();) e = e.parentWidget, e.exeEventListeners(t), e.exeEventDefault(t), e.exeEventListeners(t, !0);
				return this
			}, t.prototype.exeEventListeners = function(t, e) {
				if (!t.isListenerPrevented()) {
					t.type = t.type.toLowerCase();
					for (var i = 0, o = this.eventListeners.length; o > i; i++) {
						var s = this.eventListeners[i];
						s && s.type === t.type && s.after === !! e && s.cb.call(s.ctx, t)
					}
				}
			}, t.prototype.exeEventDefault = function(t) {
				var e = t.type + "Default";
				this[e] && this[e](t)
			}, t.prototype.destroy = function(t) {
				for (var e = 0; e < this.childWidgets.length; e++) this.childWidgets[e].destroy(t);
				this.getParentWidget() && this.getParentWidget().removeChildWidget(this), delete this.eventListeners, t && this.con.parentNode.removeChild(this.con)
			}, t.prototype._filterArray = function(t, e) {
				return t.filter(function(t, i, o) {
					return -1 === e.indexOf(t)
				})
			}, t.prototype._removeSpaces = function(t) {
				return t ? t.replace(/\s+/g, "") : ""
			}, t.prototype.parseDom = function(t) {
				var e = document.createElement("div");
				return e.innerHTML = t, e.children
			}, t.prototype.disableClick = function() {
				this.noClick = !0
			}, t.prototype.enableClick = function() {
				this.noClick = !1
			}, t.prototype.getEvents = function() {
				return ["keydown", "keyup", "ok", "okdown", "click", "focus", "blur"]
			}, t
		}();
	e["default"] = l, t.exports = e["default"]
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	function r(t, e) {
		if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
		t.prototype = Object.create(e && e.prototype, {
			constructor: {
				value: t,
				enumerable: !1,
				writable: !0,
				configurable: !0
			}
		}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var n = i(3),
		h = o(n),
		a = i(2),
		l = o(a),
		d = function(t) {
			function e(i) {
				s(this, e), t.call(this, i), this.minInterval = this.options.cfg.interval > 0 ? 1e3 * this.options.cfg.interval : 0, this.disableArea = "yes" === this.options.cfg.disable_area, this.disableShadow = "yes" === this.options.cfg.disable_shadow, this.useLeafRect = "yes" === this.options.cfg.use_leaf_rect, this.cacheRect = "yes" === this.options.cfg.disable_cache_rect ? !1 : !0
			}
			return r(e, t), e.prototype.removeChildWidget = function(e) {
				var i = t.prototype.removeChildWidget.call(this, e);
				return i === this.lastFocusedChildWidget && (this.lastFocusedChildWidget = null), i
			}, e.prototype.keydownDefault = function(t) {
				return this.isLeafWidget() ? void this.fire(new l["default"]("switchend", this, {
					keyCode: t.keyCode
				})) : void(!t.isDefaultPrevented() && t.target && -1 !== [l["default"].VK_LEFT, l["default"].VK_RIGHT, l["default"].VK_UP, l["default"].VK_DOWN].indexOf(t.keyCode) && this.doSwitch(t))
			}, e.prototype.doSwitch = function(t) {
				var e = (new Date).getTime();
				if (e - this.lastKeydownTime < this.minInterval) return void t.preventDefault();
				this.lastKeydownTime = e;
				var i = this.getFocusedChildWidget(),
					o = i.options.dir,
					s = null,
					r = void 0,
					n = void 0;
				return t.keyCode === l["default"].VK_LEFT ? (r = l["default"].VK_RIGHT, n = "left") : t.keyCode === l["default"].VK_UP ? (r = l["default"].VK_DOWN, n = "up") : t.keyCode === l["default"].VK_RIGHT ? (r = l["default"].VK_LEFT, n = "right") : t.keyCode === l["default"].VK_DOWN && (r = l["default"].VK_UP, n = "down"), "yes" !== this.options.cfg.disable_cache_pre && this.lastKeyCode === r && this.lastFocusedChildWidget && !this.lastFocusedChildWidget.disabled && (s = this.lastFocusedChildWidget), !s && o && o[n] && (s = this._queryWidgetByCfg(i, o[n])), s || this.disableShadow || "yes" === i.options.cfg.disable_self_shadow || (s = this._queryWidgetByShadowAlgorithm(i, n, t)), s || this.disableArea || "yes" === i.options.cfg.disable_self_area || (s = this._queryWidgetByAreaAlgorithm(i, n, t)), s ? (s.focus(), "yes" !== this.options.cfg.disable_cache_pre && (this.lastFocusedChildWidget = i, this.lastKeyCode = t.keyCode), void t.preventDefault()) : void this.fire(new l["default"]("switchend", this, {
					keyCode: t.keyCode
				}))
			}, e.prototype._queryWidgetByCfg = function(t, e) {
				if (-1 == e) return t;
				for (var i = 0, o = this.childWidgets.length; o > i; i++) {
					var s = this.childWidgets[i];
					if (s !== t && !s.disabled && s.options.tab === e && "none" !== s.getDOMNode().style.display) return this.childWidgets[i]
				}
				return null
			}, e.prototype._queryWidgetByShadowAlgorithm = function(t, e, i) {
				var o = t.getWidgetRect(this.cacheRect);
				(this.useLeafRect || "yes" === t.options.cfg.use_self_leaf_rect) && i && (o = i.target.getWidgetRect(this.cacheRect));
				for (var s = null, r = 1 / 0, n = 0; n < this.childWidgets.length; n++) {
					var h = this.childWidgets[n];
					if (h !== t && !h.disabled) {
						var a = h.getWidgetRect(this.cacheRect);
						"left" === e && a.right < o.right && a.left < o.left && a.top < o.bottom && a.bottom > o.top && o.right - a.right < r ? (s = h, r = o.right - a.right) : "right" === e && a.left > o.left && a.right > o.right && a.top < o.bottom && a.bottom > o.top && a.left - o.left < r ? (s = h, r = a.left - o.left) : "up" === e && a.bottom < o.bottom && a.top < o.top && a.left < o.right && a.right > o.left && o.bottom - a.bottom < r ? (s = h, r = o.bottom - a.bottom) : "down" === e && a.top > o.top && a.bottom > o.bottom && a.left < o.right && a.right > o.left && a.top - o.top < r && (s = h, r = a.top - o.top)
					}
				}
				return s
			}, e.prototype._queryWidgetByAreaAlgorithm = function(t, e, i) {
				var o = t.getWidgetRect(this.cacheRect);
				(this.useLeafRect || "yes" === t.options.cfg.use_self_leaf_rect) && i && (o = i.target.getWidgetRect(this.cacheRect));
				for (var s = null, r = 1 / 0, n = 0; n < this.childWidgets.length; n++) {
					var h = this.childWidgets[n];
					if (h !== t && !h.disabled) {
						var a = h.getWidgetRect(this.cacheRect);
						if ("left" === e && a.right <= o.left) {
							var l = 1 / 0;
							l = a.bottom < o.top ? Math.sqrt(Math.pow(o.left - a.right, 2) + Math.pow(o.top - a.bottom, 2)) : a.top > o.bottom ? Math.sqrt(Math.pow(o.left - a.right, 2) + Math.pow(a.top - o.bottom, 2)) : o.left - a.right, r > l && (s = h, r = l)
						} else if ("right" === e && a.left >= o.right) {
							var l = 1 / 0;
							l = a.bottom < o.top ? Math.sqrt(Math.pow(a.left - o.right, 2) + Math.pow(o.top - a.bottom, 2)) : a.top > o.bottom ? Math.sqrt(Math.pow(a.left - o.right, 2) + Math.pow(a.top - o.bottom, 2)) : a.left - o.right, r > l && (s = h, r = l)
						} else if ("up" === e && a.bottom <= o.top) {
							var l = 1 / 0;
							l = a.right < o.left ? Math.sqrt(Math.pow(o.top - a.bottom, 2) + Math.pow(o.left - a.right, 2)) : a.left > o.right ? Math.sqrt(Math.pow(o.top - a.bottom, 2) + Math.pow(a.left - o.right, 2)) : o.top - a.bottom, r > l && (s = h, r = l)
						} else if ("down" === e && a.top >= o.bottom) {
							var l = 1 / 0;
							l = a.right < o.left ? Math.sqrt(Math.pow(a.top - o.bottom, 2) + Math.pow(o.left - a.right, 2)) : a.left > o.right ? Math.sqrt(Math.pow(a.top - o.bottom, 2) + Math.pow(a.left - o.right, 2)) : a.top - o.bottom, r > l && (s = h, r = l)
						}
					}
				}
				return s
			}, e.prototype.getEvents = function() {
				return t.prototype.getEvents.call(this).concat(["switchend"])
			}, e
		}(h["default"]);
	e["default"] = d, t.exports = e["default"]
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	function r(t, e) {
		if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
		t.prototype = Object.create(e && e.prototype, {
			constructor: {
				value: t,
				enumerable: !1,
				writable: !0,
				configurable: !0
			}
		}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var n = i(4),
		h = o(n),
		a = i(2),
		l = o(a),
		d = i(6),
		c = o(d),
		f = function(t) {
			function e(i) {
				var o = this;
				if (s(this, e), t.call(this, i), this.cacheRect = !1, this.dir = "h" === this.options.cfg.dir ? this.options.cfg.dir : "v", this.centerDOM = "document" === this.options.cfg.center ? this.options.cfg.center : "con", this.duration = this.options.cfg.duration ? parseFloat(this.options.cfg.duration) : .2, this.speedup = this.options.cfg.speedup ? parseFloat(this.options.cfg.speedup) : .6, this.easing = this.options.cfg.easing ? this.options.cfg.easing : "ease-out", this.speedupEasing = this.options.cfg.speedup_easing ? this.options.cfg.speedup_easing : "linear", this.useRAF = "yes" === this.options.cfg.use_ram || "yes" === this.options.cfg.use_raf, this.lazyload = "yes" !== this.options.cfg.disable_lazyload, this.lazyloadDelay = void 0 !== this.options.cfg.lazyload_delay ? parseFloat(this.options.cfg.lazyload_delay) : .1, this.autoListWidth = "yes" === this.options.cfg.auto_list_width, this.conList = this.con.querySelector(".scroll-list"), this.offset = 0, this.desArr = [], !this.conList) return void console.error("[FocusEngine_Error]Scroll组件必须含有一个类名为scroll-list的子元素。");
				var r = getComputedStyle(this.conList);
				"auto" !== r.left && 0 !== parseInt(r.left) && "h" === this.dir && console.error("[FocusEngine_Error]横向Scroll容器的.scroll-list子元素不可设置left值"), "auto" !== r.top && 0 !== parseInt(r.top) && "v" === this.dir && console.error("[FocusEngine_Error]纵向Scroll容器的.scroll-list子元素不可设置top值"), "static" === r.position && (this.conList.style.position = "relative"), this._render(), this.autoListWidth && this._setAutoListWidth();
				var n = this.getDefaultFocusedChildWidget();
				n && this.scrollToWidget(n, 0), this.lazyload && setTimeout(function() {
					o.loadVisibleImage()
				}, 10)
			}
			return r(e, t), e.prototype._computeScrollRect = function() {
				if (this.conRect = this.getWidgetRect(), this.conWidth = this.conRect.width, this.conHeight = this.conRect.height, this.listRect = this.conList.getBoundingClientRect(), this.listWidth = this.listRect.width, this.listHeight = this.listRect.height, "document" === this.centerDOM) {
					var t = document.documentElement.getBoundingClientRect();
					"v" === this.dir ? this.center = t.height / 2 : this.center = t.width / 2
				} else "v" === this.dir ? this.center = this.conRect.height / 2 : this.center = this.conRect.width / 2
			}, e.prototype._setAutoListWidth = function() {
				this.rightPaddingWithUnit = this.options.cfg.right_padding, this.rightPadding = 0, this.rightPaddingWithUnit && (-1 !== this.rightPaddingWithUnit.indexOf("rem") ? this.rightPadding = parseFloat(this.rightPaddingWithUnit) * parseFloat(document.querySelector("html").style.fontSize) : this.rightPadding = parseFloat(this.rightPaddingWithUnit)), this.conList.style.width = "99999px";
				for (var t = 0, e = this.childWidgets.length; e > t; t++) {
					var i = this.childWidgets[t].getWidgetRect().right,
						o = i - this.listRect.left + this.rightPadding;
					o > this.listWidth && (this.listWidth = o)
				}
				this.conList.style.width = this.listWidth + "px"
			}, e.prototype.reRender = function() {
				var t = this;
				if (document.querySelector("#" + this.id)) {
					if (this.con = document.querySelector("#" + this.id), this.conList = this.con.querySelector(".scroll-list"), !this.conList) return void console.error("[FocusEngine_Error]Scroll组件必须含有一个类名为scroll-list的子元素。");
					var e = getComputedStyle(this.conList);
					"static" === e.position && (this.conList.style.position = "relative"), this.options = this._getOptions(this.con), this.dir = "h" === this.options.cfg.dir ? this.options.cfg.dir : "v", this.centerDOM = "ducoment" === this.options.cfg.center ? this.options.cfg.center : "con", this.duration = this.options.cfg.duration ? parseFloat(this.options.cfg.duration) : .2, this.easing = this.options.cfg.easing ? this.options.cfg.easing : "linear", this.useRAF = "yes" === this.options.cfg.use_ram || "yes" === this.options.cfg.use_raf, this._render(!0), this._reRenderChildWidget(), this.autoListWidth && this._setAutoListWidth(), this.lazyload && setTimeout(function() {
						t.loadVisibleImage()
					}, 10)
				}
			}, e.prototype._render = function(t) {
				var e = this;
				this._computeScrollRect(), t || ("v" === this.dir ? this.conList.style.top = "0px" : this.conList.style.left = "0px"), this.useRAF || ("v" === this.dir ? (this.conList.style.transition = "top " + this.duration + "s " + this.easing, this.conList.style.webkitTransition = "top " + this.duration + "s " + this.easing) : (this.conList.style.transition = "left " + this.duration + "s " + this.easing, this.conList.style.webkitTransition = "left " + this.duration + "s " + this.easing), t || (this.rendered = !1, this.conList.addEventListener("webkitTransitionEnd", function(t) {
					t.target === e.conList && (e.rendered && e.fire(new l["default"]("scrollend", e)), e.rendered = !0)
				}), this.conList.addEventListener("transitionend", function(t) {
					t.target === e.conList && (e.rendered && e.fire(new l["default"]("scrollend", e)), e.rendered = !0)
				})))
			}, e.prototype.focusDefault = function(e) {
				if (t.prototype.focusDefault.call(this, e), this.getFirstFocusableChildWidget() && !e.isDefaultPrevented()) {
					if (!(this.conWidth || this.conHeight || this.listWidth || this.listHeight || this.center)) {
						this._computeScrollRect(), this.autoListWidth && this._setAutoListWidth();
						var i = this.getDefaultFocusedChildWidget();
						if (i) return void this.scrollToWidget(i, 0)
					}
					this.doScroll(e)
				}
			}, e.prototype.scrollstartDefault = function(t) {
				this.loadImageTimeout && clearTimeout(this.loadImageTimeout)
			}, e.prototype.scrollendDefault = function(t) {
				var e = this;
				this.lazyload && t.target === this && (this.loadImageTimeout = setTimeout(function() {
					e.loadVisibleImage()
				}, 1e3 * this.lazyloadDelay))
			}, e.prototype.doSwitch = function(e) {
				t.prototype.doSwitch.call(this, e)
			}, e.prototype.doScroll = function(t) {
				var e = this.getFocusedChildWidget();
				this.scrollToWidget(e, this.duration, t)
			}, e.prototype.scrollToWidget = function(t, e, i) {
				var o = this.computeOffsetByWidget(t);
				return void 0 === e && (e = this.duration), this.scrollListTo(o, e, i), this
			}, e.prototype.computeOffsetByWidget = function(t) {
				if ("yes" === t.options.cfg.to_start) return 0;
				if ("yes" === t.options.cfg.to_end) return "v" === this.dir ? this.conHeight - this.listHeight : this.conWidth - this.listWidth;
				this._computeScrollRect();
				var e = this.center - this._getExpectCenter(t);
				if ("v" === this.dir) {
					if (0 > e) {
						if (this.offset + e < this.conHeight - this.listHeight && (e = this.conHeight - this.listHeight - this.offset, e > 0)) return this.offset
					} else {
						if (!(e > 0)) return this.offset;
						if (-1 * this.offset < e && (e = -1 * this.offset, 0 > e)) return this.offset
					}
					return this.offset + e
				}
				if (0 > e) {
					if (this.offset + e < this.conWidth - this.listWidth && (e = this.conWidth - this.listWidth - this.offset, e > 0)) return this.offset
				} else {
					if (!(e > 0)) return this.offset;
					if (-1 * this.offset < e && (e = -1 * this.offset, 0 > e)) return this.offset
				}
				return this.offset + e
			}, e.prototype.scrollListTo = function(t, e, i) {
				var o = this;
				if (void 0 === e && (e = this.duration), this.fire(new l["default"]("scrollstart", this)), this.useRAF) {
					if (this.desArr.length > 0 && t === this.desArr[this.desArr.length - 1]) return;
					i && "focus" === i.type && (this.futureOffset = t), this.desArr.push(t), 1 === this.desArr.length && this.doAnimate(e, this.easing)
				} else this.offset = t, "v" === this.dir ? (this.conList.style.transition = "top " + e + "s " + this.easing, this.conList.style.webkitTransition = "top " + e + "s " + this.easing) : (this.conList.style.transition = "left " + e + "s " + this.easing, this.conList.style.webkitTransition = "left " + e + "s " + this.easing), setTimeout(function() {
					"v" === o.dir ? (o.conList.style.transition = "top " + o.duration + "s " + o.easing, o.conList.style.webkitTransition = "top " + o.duration + "s " + o.easing) : (o.conList.style.transition = "left " + o.duration + "s " + o.easing, o.conList.style.webkitTransition = "left " + o.duration + "s " + o.easing)
				}, 1), "v" === this.dir ? this.conList.style.top = this.offset + "px" : this.conList.style.left = this.offset + "px", i && "focus" === i.type && (this.futureOffset = this.offset);
				return this
			}, e.prototype.doAnimate = function(t, e, i) {
				var o = this;
				if (this.desArr[0] === this.offset) return this.desArr.shift(), void this.doAnimate(t, e);
				if (0 === this.desArr.length) return void this.fire(new l["default"]("scrollend", this));
				var s = function() {
						o.scrollEndTimeout && clearTimeout(o.scrollEndTimeout), o.offset = o.desArr.shift(), o.desArr.length > 0 ? o.doAnimate(t, e, !0) : o.scrollEndTimeout = setTimeout(function() {
							o.fire(new l["default"]("scrollend", o))
						}, 50)
					};
				(0, c["default"])({
					dom: this.conList,
					style: "v" === this.dir ? "top" : "left",
					start: this.offset,
					end: this.desArr[0],
					duration: i ? t * this.speedup : t,
					easing: e,
					cb: s
				})
			}, e.prototype._getExpectCenter = function(t) {
				var e = t.getWidgetRect();
				return "v" === this.dir ? this.offset + e.centerY - this.listRect.top : this.offset + e.centerX - this.listRect.left
			}, e.prototype.getListNode = function() {
				return this.conList
			}, e.prototype.loadVisibleImage = function() {
				for (var t = this.getWidgetRect(), e = t.left, i = t.top, o = t.right, s = t.bottom, r = this.con.querySelectorAll(".fe-lazyload"), n = function(t) {
						var n = r[t],
							h = n.getAttribute("fe-src"),
							a = n.getBoundingClientRect();
						if (n.src !== h && !(a.left <= e && a.right <= e || a.left >= o && a.right >= o || a.top >= s && a.bottom >= s || a.top <= i && a.bottom <= i)) {
							var l = new Image;
							l.src = h, l.onload = function() {
								n.src = h
							}
						}
					}, h = 0; h < r.length; h++) n(h)
			}, e.prototype.getEvents = function() {
				return t.prototype.getEvents.call(this).concat(["scrollstart", "scrollend"])
			}, e
		}(h["default"]);
	e["default"] = f, t.exports = e["default"]
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t) {
		if (!(t && t.dom && t.style && void 0 !== t.end)) return void console.error("[FocusEngine_Error]animate方法的cfg参数：dom、style、end必需！");
		var e = t.dom,
			i = t.style,
			o = "css" === t.transitionType ? "css" : "js",
			s = t.start;
		if (void 0 === s) {
			var r = parseFloat(getComputedStyle(e)[i]);
			s = isNaN(r) ? r : 0
		}
		var n = t.end,
			a = void 0 !== t.duration ? parseFloat(t.duration) : .3,
			l = 1e3 * a,
			d = t.easing || "ease-out",
			c = t.unit || "px",
			f = t.cb || null;
		if ("css" === o) {
			var u = function() {
					var t = "";
					d.constructor === Array ? t = "cubic-bezier(" + d.join(",") + ")" : d.constructor === String && (t = d);
					var o = function s(t) {
							t.target === e && (e.style.transition = "", e.removeEventListener("transitionend", s), f && f())
						};
					return e.addEventListener("transitionend", o), e.style.transition = i + " " + a + "s " + t, e.style[i] = n + c, {
						v: void 0
					}
				}();
			if ("object" == typeof u) return u.v
		}
		var g = null;
		d.constructor === Array ? g = h.custom(d) : d.constructor === String && (g = h[d]);
		var p = l / 14,
			y = 1,
			v = function w() {
				if (y > p) e.style[i] = n + c, f && f();
				else {
					var t = g(y / p),
						o = s + t * (n - s);
					e.style[i] = o + c, y++, window.requestAnimationFrame(w)
				}
			};
		window.requestAnimationFrame(v)
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var r = i(7),
		n = o(r);
	window.requestAnimationFrame = window.requestAnimationFrame ||
	function(t) {
		setTimeout(t, 0)
	};
	var h = {
		linear: function(t) {
			return t
		},
		ease: n["default"].apply(null, [.25, .1, .25, 1]),
		"ease-in": n["default"].apply(null, [.42, 0, 1, 1]),
		"ease-out": n["default"].apply(null, [0, 0, .58, 1]),
		"ease-in-out": n["default"].apply(null, [.42, 0, .58, 1]),
		custom: function(t) {
			return n["default"].apply(null, t)
		}
	};
	window.animate = s, e["default"] = s, t.exports = e["default"]
}, function(t, e) {
	"use strict";

	function i(t, e) {
		return 1 - 3 * e + 3 * t
	}
	function o(t, e) {
		return 3 * e - 6 * t
	}
	function s(t) {
		return 3 * t
	}
	function r(t, e, r) {
		return ((i(e, r) * t + o(e, r)) * t + s(e)) * t
	}
	function n(t, e, r) {
		return 3 * i(e, r) * t * t + 2 * o(e, r) * t + s(e)
	}
	function h(t, e, i, o, s) {
		var n, h, a = 0;
		do h = e + (i - e) / 2, n = r(h, o, s) - t, n > 0 ? i = h : e = h;
		while (Math.abs(n) > c && ++a < f);
		return h
	}
	function a(t, e, i, o) {
		for (var s = 0; l > s; ++s) {
			var h = n(e, i, o);
			if (0 === h) return e;
			var a = r(e, i, o) - t;
			e -= a / h
		}
		return e
	}
	var l = 4,
		d = .001,
		c = 1e-7,
		f = 10,
		u = 11,
		g = 1 / (u - 1),
		p = "function" == typeof Float32Array;
	t.exports = function(t, e, i, o) {
		function s(e) {
			for (var o = 0, s = 1, r = u - 1; s !== r && l[s] <= e; ++s) o += g;
			--s;
			var c = (e - l[s]) / (l[s + 1] - l[s]),
				f = o + c * g,
				p = n(f, t, i);
			return p >= d ? a(e, f, t, i) : 0 === p ? f : h(e, o, o + g, t, i)
		}
		if (!(t >= 0 && 1 >= t && i >= 0 && 1 >= i)) throw new Error("bezier x values must be in [0, 1] range");
		var l = p ? new Float32Array(u) : new Array(u);
		if (t !== e || i !== o) for (var c = 0; u > c; ++c) l[c] = r(c * g, t, i);
		return function(n) {
			return t === e && i === o ? n : 0 === n ? 0 : 1 === n ? 1 : r(s(n), e, o)
		}
	}
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	function r(t, e) {
		if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
		t.prototype = Object.create(e && e.prototype, {
			constructor: {
				value: t,
				enumerable: !1,
				writable: !0,
				configurable: !0
			}
		}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var n = i(3),
		h = o(n),
		a = i(2),
		l = o(a),
		d = i(6),
		c = o(d),
		f = function(t) {
			function e(i) {
				s(this, e), t.call(this, i), this._init(), this._writeGridInnerHTML(), t.prototype._initChildWidgets.call(this), this["_checkWidgets_" + this.dir]()
			}
			return r(e, t), e.prototype._initChildWidgets = function() {}, e.prototype.reRender = function() {}, e.prototype._init = function() {
				return this.dir = "h" === this.options.cfg.dir ? "h" : "v", this.style = "h" === this.options.cfg.dir ? "left" : "top", isNaN(this.options.cfg.row) || isNaN(this.options.cfg.col) ? void console.error("[FocusEngine_Error]Grid组件必须设置行和列！行列数为视口内可见的最多行列数。") : (this.duration = void 0 !== this.options.cfg.duration ? parseFloat(this.options.cfg.duration) : .3, this.speedupDuration = void 0 !== this.options.cfg.speedup_duration ? parseFloat(this.options.cfg.speedup_duration) : .6 * this.duration, this.easing = this.options.cfg.easing ? this.options.cfg.easing : "ease-out", this.speedupEasing = this.options.cfg.speedup_easing ? this.options.cfg.speedup_easing : "linear", this.delay = void 0 !== this.options.cfg.delay ? parseFloat(this.options.cfg.delay) : 0, this.noEmpty = "yes" === this.options.cfg.no_empty, this.delay > 0 && this.delay < .05 && (this.delay = .05), this.delayStyle = "1" === this.options.cfg.delay_style ? 1 : 0, this.data = this.data || [], this.itemRender = this.itemRender || null, this.scrolling = !1, this.originSize = this.options.cfg.origin_size ? parseInt(this.options.cfg.origin_size) : 1, this.origin = 0, this.dataIndex = 0, void this["_init_more_" + this.dir]())
			}, e.prototype._init_more_v = function() {
				this.row = parseInt(this.options.cfg.row) + 2, this.col = parseInt(this.options.cfg.col), this.originSize > 1 ? this.row = this.originSize + 2 : this.row % 2 === 0 && this.row++, this.upRow = 0, this.downRow = this.row - 1
			}, e.prototype._init_more_h = function() {
				this.row = parseInt(this.options.cfg.row), this.col = parseInt(this.options.cfg.col) + 2, this.originSize > 1 ? this.col = this.originSize + 2 : this.col % 2 === 0 && this.col++, this.lefCol = 0, this.rightCol = this.col - 1
			}, e.prototype._writeGridInnerHTML = function() {
				var t = this.con.children[0];
				t.id = "", this.templateHTML = t.outerHTML, this.con.innerHTML = "", this["_writeGridInnerHTML_" + this.dir]()
			}, e.prototype._writeGridInnerHTML_v = function() {
				for (var t = "", e = 0; e < this.col; e++) t += this.templateHTML;
				t += '<div style="clear:both;"></div>';
				for (var e = 0; e < this.row; e++) {
					var i = document.createElement("div");
					i.innerHTML = t, i.style.position = "relative", this.con.appendChild(i)
				}
			}, e.prototype._writeGridInnerHTML_h = function() {
				for (var t = "", e = 0; e < this.row; e++) t += this.templateHTML + '<div style="clear:both;"></div>';
				var i = document.createElement("div");
				i.style.width = "99999px", i.style.height = "100%";
				for (var e = 0; e < this.col; e++) {
					var o = document.createElement("div");
					o.innerHTML = t, o.style.position = "relative", o.style["float"] = "left", i.appendChild(o)
				}
				i.appendChild(this.parseDom('<div style="clear:both;"></div>')[0]), this.con.appendChild(i)
			}, e.prototype._checkWidgets_v = function() {
				this.widgetArr = [];
				for (var t = 0, e = 0, i = this.childWidgets.length; i > e; e += this.col) {
					var o = this.childWidgets.slice(e, e + this.col);
					o = o.map(function(e, i) {
						return e.row = t, e.col = i, e
					}), this.widgetArr.push(o), t++
				}
				var s = this.getWidgetRect();
				if (this.conHeight = s.height, this.rowHeight = this.childWidgets[0].con.parentNode.getBoundingClientRect().height, this.originArr = [], 1 === this.originSize) this.originArr.push(this.conHeight / 2);
				else for (var e = 0, r = this.rowHeight / 2; e < this.originSize; e++) this.originArr.push(r + e * this.rowHeight);
				this.curWid = this.childWidgets[0];
				for (var e = 0; e < this.childWidgets.length; e++) {
					var n = this.childWidgets[e];
					getComputedStyle(n.getDOMNode());
					n.oriOffsetCY = n.getWidgetRect().centerY - s.top, n.oriCenteY = n.oriOffsetCY, n.offset = 0, n.animationArr = [], n.isEmpty = !0, n.offsetRow = n.row, n.whichData = e
				}
			}, e.prototype._checkWidgets_h = function() {
				this.widgetArr = [];
				for (var t = 0, e = 0, i = this.childWidgets.length; i > e; e += this.row) {
					var o = this.childWidgets.slice(e, e + this.row);
					o = o.map(function(e, i) {
						return e.col = t, e.row = i, e
					}), this.widgetArr.push(o), t++
				}
				var s = this.getWidgetRect();
				if (this.conWidth = s.width, this.colWidth = this.childWidgets[0].con.parentNode.getBoundingClientRect().width, this.originArr = [], 1 === this.originSize) this.originArr.push(this.conWidth / 2);
				else for (var e = 0, r = this.colWidth / 2; e < this.originSize; e++) this.originArr.push(r + e * this.colWidth);
				this.curWid = this.childWidgets[0];
				for (var e = 0; e < this.childWidgets.length; e++) {
					var n = this.childWidgets[e];
					getComputedStyle(n.getDOMNode());
					n.oriOffsetCX = n.getWidgetRect().centerX - s.left, n.oriCenteX = n.oriOffsetCX, n.offset = 0, n.animationArr = [], n.isEmpty = !0, n.offsetCol = n.col, n.whichData = e
				}
			}, e.prototype.keydownDefault = function(t) {
				return this.stopSwitch ? void t.preventDefault() : void(t.isDefaultPrevented() || this["_keydownDefault_" + this.dir](t))
			}, e.prototype._keydownDefault_v = function(t) {
				var e = this._getNextDataIndex_v(t.keyCode);
				if (-1 !== e) {
					t.preventDefault();
					var i = this.childWidgets[Math.floor(e / this.col) % this.row * this.col + e % this.col];
					i.focus()
				}
			}, e.prototype._keydownDefault_h = function(t) {
				var e = this._getNextDataIndex_h(t.keyCode);
				if (-1 !== e) {
					t.preventDefault();
					var i = this.childWidgets[Math.floor(e / this.row) % this.col * this.row + e % this.row];
					i.focus()
				}
			}, e.prototype._getNextDataIndex_v = function(t) {
				var e = this.dataIndex;
				return t === l["default"].VK_LEFT ? e % this.col !== 0 ? --e : -1 : t === l["default"].VK_RIGHT ? e % this.col !== this.col - 1 && e + 1 < this.data.length ? ++e : -1 : t === l["default"].VK_UP ? e >= this.col ? e -= this.col : -1 : t === l["default"].VK_DOWN ? e + this.col < this.data.length ? e += this.col : e + this.col >= this.data.length && Math.floor(e / this.col) < Math.floor((this.data.length - 1) / this.col) ? this.data.length - 1 : (this.fire(new l["default"]("reachend", this)), -1) : -1
			}, e.prototype._getNextDataIndex_h = function(t) {
				var e = this.dataIndex;
				return t === l["default"].VK_LEFT ? e >= this.row ? e -= this.row : -1 : t === l["default"].VK_RIGHT ? e + this.row < this.data.length ? e += this.row : e + this.row >= this.data.length && Math.floor(e / this.row) < Math.floor((this.data.length - 1) / this.row) ? this.data.length - 1 : (this.fire(new l["default"]("reachend", this)), -1) : t === l["default"].VK_UP ? e % this.row !== 0 ? --e : -1 : t === l["default"].VK_DOWN && e % this.row !== this.row - 1 && e + 1 < this.data.length ? ++e : -1
			}, e.prototype.focusDefault = function(e) {
				t.prototype.focusDefault.call(this, e), this.isSetData || (this.conHeight || this.conWidth || this["_checkWidgets_" + this.dir](), this["_focusDefault_" + this.dir](e))
			}, e.prototype._focusDefault_v = function(t) {
				var e = this.getFocusedChildWidget();
				this.dataIndex = e.whichData, this.curWid = e, 0 !== e.offsetRow && (this._computeGridStatus_v(e), this._computeAllWidgetStatus_v(e), this._triggerWidgetsAnimation_v(e))
			}, e.prototype._focusDefault_h = function(t) {
				var e = this.getFocusedChildWidget();
				this.dataIndex = e.whichData, this.curWid = e, 0 !== e.offsetCol && (this._computeGridStatus_h(e), this._computeAllWidgetStatus_h(e), this._triggerWidgetsAnimation_h(e))
			}, e.prototype._computeGridStatus_v = function(t) {
				if (this.isSetData || (this.isUp = t.offsetRow < 0, this.isUp && this.origin > 0 ? this.origin-- : !this.isUp && this.origin < this.originArr.length - 1 && this.origin++), this.focsedCY = this.originArr[this.origin], 1 === this.originSize) {
					this.upRow = Math.floor(this.row / 2), this.downRow = Math.floor(this.row / 2);
					var e = Math.floor(this.dataIndex / this.col),
						i = Math.floor((this.data.length - 1) / this.col),
						o = this.focsedCY,
						s = (i - e) * this.rowHeight + this.rowHeight / 2;
					o > s && (this.focsedCY = this.conHeight - s, this.downRow = i - e, this.upRow = this.row - 1 - this.downRow);
					var r = e * this.rowHeight + this.rowHeight / 2,
						n = (i + 1) * this.rowHeight;
					if (o > r || n < this.conHeight) return this.focsedCY = r, this.upRow = e, void(this.downRow = this.row - 1 - this.upRow)
				} else {
					if (this.upRow = this.origin + 1, this.downRow = this.originSize - this.origin, 0 === Math.floor(this.dataIndex / this.col)) return this.upRow = 0, void(this.downRow = this.row - 1);
					Math.floor(this.dataIndex / this.col) === Math.floor((this.data.length - 1) / this.col) && (this.upRow = this.row - 1, this.downRow = 0)
				}
			}, e.prototype._computeGridStatus_h = function(t) {
				if (this.isSetData || (this.isLeft = t.offsetCol < 0, this.isLeft && this.origin > 0 ? this.origin-- : !this.isLeft && this.origin < this.originArr.length - 1 && this.origin++), this.focsedCX = this.originArr[this.origin], 1 === this.originSize) {
					this.leftCol = Math.floor(this.col / 2), this.rightCol = Math.floor(this.col / 2);
					var e = Math.floor(this.dataIndex / this.row),
						i = Math.floor((this.data.length - 1) / this.row),
						o = this.focsedCX,
						s = (i - e) * this.colWidth + this.colWidth / 2;
					o > s && (this.focsedCX = this.conWidth - s, this.rightCol = i - e, this.leftCol = this.col - 1 - this.rightCol);
					var r = e * this.colWidth + this.colWidth / 2,
						n = (i + 1) * this.colWidth;
					if (o > r || n < this.conWidth) return this.focsedCX = r, this.leftCol = e, void(this.rightCol = this.col - 1 - this.leftCol)
				} else {
					if (this.leftCol = this.origin + 1, this.rightCol = this.originSize - this.origin, this.dataIndex < this.row) return this.leftCol = 0, void(this.rightCol = this.col - 1);
					Math.floor(this.dataIndex / this.row) === Math.floor((this.data.length - 1) / this.row) && (this.leftCol = this.col - 1, this.rightCol = 0)
				}
			}, e.prototype._computeAllWidgetStatus_v = function(t) {
				var e = t.row,
					i = Math.floor(this.dataIndex / this.col);
				this._computeRowWidgetStatus_v(e, i, 0);
				for (var o = -1; o >= -this.upRow; o--) this._computeRowWidgetStatus_v(e, i, o);
				for (var o = 1; o <= this.downRow; o++) this._computeRowWidgetStatus_v(e, i, o)
			}, e.prototype._computeAllWidgetStatus_h = function(t) {
				var e = t.col,
					i = Math.floor(this.dataIndex / this.row);
				this._computeColWidgetStatus_h(e, i, 0);
				for (var o = -1; o >= -this.leftCol; o--) this._computeColWidgetStatus_h(e, i, o);
				for (var o = 1; o <= this.rightCol; o++) this._computeColWidgetStatus_h(e, i, o)
			}, e.prototype._computeRowWidgetStatus_v = function(t, e, i) {
				for (var o = (t + i + this.row) % this.row, s = e + i, r = 0; r < this.col; r++) {
					var n = this.childWidgets[this.col * o + r],
						h = this.col * s + r,
						a = 1;
					if ((h >= this.data.length || 0 > h) && (a = 0), n.whichData = h, n.whichDataRow = s, this.isSetData) n.offset = this.focsedCY + i * this.rowHeight - n.oriCenteY, n.con.parentNode.style.top = n.offset + "px", n.con.style.opacity = a, n.offsetRow = i;
					else {
						var l = this.focsedCY + i * this.rowHeight - n.oriCenteY;
						n.futureOffset = l, n.animationArr.push({
							offset: l,
							jump: n.offsetRow * i < 0,
							opacity: a
						}), n.offsetRow = i
					}
				}
			}, e.prototype._computeColWidgetStatus_h = function(t, e, i) {
				for (var o = (t + i + this.col) % this.col, s = e + i, r = 0; r < this.row; r++) {
					var n = this.childWidgets[this.row * o + r],
						h = s * this.row + r,
						a = 1;
					if ((h >= this.data.length || 0 > h) && (a = 0), n.whichData = h, n.whichDataCol = s, this.isSetData) n.offset = this.focsedCX + i * this.colWidth - n.oriCenteX, n.con.parentNode.style.left = n.offset + "px", n.con.style.opacity = a, n.offsetCol = i;
					else {
						var l = this.focsedCX + i * this.colWidth - n.oriCenteX;
						n.futureOffset = l, n.animationArr.push({
							offset: l,
							jump: n.offsetCol * i < 0,
							opacity: a
						}), n.offsetCol = i
					}
				}
			}, e.prototype._triggerWidgetsAnimation_v = function() {
				for (var t = 0; t < this.row; t++) {
					var e = this.widgetArr[t][0];
					if (1 !== e.animationArr.length) return;
					this["_startScroll_" + this.dir](e)
				}
			}, e.prototype._triggerWidgetsAnimation_h = function() {
				for (var t = 0; t < this.col; t++) {
					var e = this.widgetArr[t][0];
					if (1 !== e.animationArr.length) return;
					this["_startScroll_" + this.dir](e)
				}
			}, e.prototype._startScroll_v = function(t, e) {
				for (var i = this, o = this.widgetArr[t.row], s = 0, r = o.length; r > s; s++) {
					var n = o[s],
						h = n.animationArr[0];
					if (h.jump) if (this.noEmpty) {
						var a = this.data[n.whichData];
						a && (this.itemRender(n.getDOMNode(), a), n.isEmpty = !1)
					} else n.isEmpty || (this.itemRender(n.getDOMNode()), n.isEmpty = !0)
				}
				var d = function() {
						for (var e = 0, s = o.length; s > e; e++) {
							var r = o[e],
								n = r.animationArr.shift();
							r.offset = n.offset, r.con.style.opacity = n.opacity
						}
						t.animationArr.length > 0 ? i._startScroll_v(t, !0) : i.scrolling && 0 === t.row && (i.scrolling = !1, i.fire(new l["default"]("scrollend", i)))
					};
				this.stopSwitch = t.animationArr.length >= 2;
				var f = t.animationArr[0];
				f.offset === t.offset || f.jump || this.scrolling || (this.scrolling = !0, this.fire(new l["default"]("scrollstart", this, {
					distance: f.offset - t.offset
				}))), (0, c["default"])({
					dom: t.con.parentNode,
					style: this.style,
					start: f.jump ? f.offset : t.offset,
					end: f.offset,
					duration: e ? this.speedupDuration : this.duration,
					easing: e ? this.speedupEasing : this.easing,
					cb: d
				})
			}, e.prototype._startScroll_h = function(t, e) {
				for (var i = this, o = this.widgetArr[t.col], s = 0, r = o.length; r > s; s++) {
					var n = o[s],
						h = n.animationArr[0];
					if (h.jump) if (this.noEmpty) {
						var a = this.data[n.whichData];
						a && (this.itemRender(n.getDOMNode(), a), n.isEmpty = !1)
					} else n.isEmpty || (this.itemRender(n.getDOMNode()), n.isEmpty = !0)
				}
				var d = function() {
						for (var e = 0, s = o.length; s > e; e++) {
							var r = o[e],
								n = r.animationArr.shift();
							r.offset = n.offset, r.con.style.opacity = n.opacity
						}
						t.animationArr.length > 0 ? i._startScroll_h(t, !0) : i.scrolling && 0 === t.col && (i.scrolling = !1, i.fire(new l["default"]("scrollend", i)))
					};
				this.stopSwitch = t.animationArr.length >= 2;
				var f = t.animationArr[0];
				f.offset === t.offset || f.jump || this.scrolling || (this.scrolling = !0, this.fire(new l["default"]("scrollstart", this, {
					distance: f.offset - t.offset
				}))), (0, c["default"])({
					dom: t.con.parentNode,
					style: this.style,
					start: f.jump ? f.offset : t.offset,
					end: f.offset,
					duration: e ? this.speedupDuration : this.duration,
					easing: e ? this.speedupEasing : this.easing,
					cb: d
				})
			}, e.prototype.scrollendDefault = function(t) {
				t.isDefaultPrevented() || this.scrolling || this["_toggleDelay_" + this.dir](0)
			}, e.prototype.scrollstartDefault = function(t) {
				t.isDefaultPrevented() || (this["_toggleDelay_" + this.dir](t.distance), this.loadContentTimeout && clearTimeout(this.loadContentTimeout), window.stopImgLoading && window.stopImgLoading())
			}, e.prototype._toggleDelay_v = function() {
				var t = this,
					e = arguments.length <= 0 || void 0 === arguments[0] ? 0 : arguments[0],
					i = this.getFocusedChildWidget() || this.getCachedChildWidget();
				if (i) for (var o = i.col, s = 0; s < this.col; s++) for (var r = 0; r < this.row; r++) {
					var n = this.widgetArr[r][s],
						h = -(e * this.delay * Math.abs(n.col - o * this.delayStyle)),
						a = null;
					0 === h && 0 === s && 0 === r && (a = function() {
						t.loadContent()
					}), (0, c["default"])({
						dom: n.con,
						style: this.style,
						start: n.delayOffset || 0,
						end: h,
						duration: this.duration,
						easing: "ease-out",
						cb: a
					}), n.delayOffset = h
				}
			}, e.prototype._toggleDelay_h = function() {
				var t = this,
					e = arguments.length <= 0 || void 0 === arguments[0] ? 0 : arguments[0],
					i = this.getFocusedChildWidget() || this.getCachedChildWidget();
				if (i) for (var o = i.row, s = 0; s < this.row; s++) for (var r = 0; r < this.col; r++) {
					var n = this.widgetArr[r][s],
						h = -(e * this.delay * Math.abs(n.row - o * this.delayStyle)),
						a = null;
					0 === h && 0 === s && 0 === r && (a = function() {
						t.loadContent()
					}), (0, c["default"])({
						dom: n.con,
						style: this.style,
						start: n.delayOffset || 0,
						end: h,
						duration: this.duration,
						easing: "ease-out",
						cb: a
					}), n.delayOffset = h
				}
			}, e.prototype.setItemRender = function(t) {
				return this.itemRender = function(e, i) {
					t(e, i), e.createTextGraphics && e.createTextGraphics()
				}, this
			}, e.prototype.addData = function(t) {
				if (Array.isArray(t)) {
					var e = this.data.concat(t),
						i = this.focused ? this.getFocusedChildWidget().whichData : this.dataIndex;
					return this.setData(e, i, this.origin), this
				}
			}, e.prototype.setData = function(t, e, i) {
				Array.isArray(t) && (this.data = t.concat([])), this.isSetData = !0, this.allDataCol = Math.floor(this.data.length / this.row), this.allDataRow = Math.floor(this.data.length / this.col), void 0 !== e && e < this.data.length ? this.dataIndex = e : this.dataIndex = 0, this.origin = this["_getSetDataOrigin_" + this.dir](this.data.length, this.dataIndex, i);
				var o = this["_getWidgetByDataIndex_" + this.dir](this.dataIndex);
				return this["_computeGridStatus_" + this.dir](o), this["_computeAllWidgetStatus_" + this.dir](o), o.dataIndex = this.dataIndex, this.focused ? o.focus(!0, !0) : o.cache(), this.curWid = o, this.loadContent(), this.isSetData = !1, this
			}, e.prototype._getWidgetByDataIndex_v = function(t) {
				return this.childWidgets[Math.floor(t / this.col) % this.row * this.col + t % this.col]
			}, e.prototype._getWidgetByDataIndex_h = function(t) {
				return this.childWidgets[Math.floor(t / this.row) % this.col * this.row + t % this.row]
			}, e.prototype._getSetDataOrigin_v = function(t, e, i) {
				(void 0 === i || i > this.originSize) && (i = 0);
				var o = Math.floor(this.dataIndex / this.col),
					s = Math.floor((this.data.length - 1) / this.col);
				if (s - o < this.originSize) {
					var r = o + this.originSize - s - 1;
					r >= 0 && r > i && (i = r)
				}
				if (o < this.originSize) {
					var n = o;
					i > n && (i = n)
				}
				return i
			}, e.prototype._getSetDataOrigin_h = function(t, e, i) {
				(void 0 === i || i > this.originSize) && (i = 0);
				var o = Math.floor(this.dataIndex / this.row),
					s = Math.floor((this.data.length - 1) / this.row);
				if (s - o < this.originSize) {
					var r = o + this.originSize - s - 1;
					r >= 0 && r > i && (i = r)
				}
				if (o < this.originSize) {
					var n = o;
					i > n && (i = n)
				}
				return i
			}, e.prototype.loadContent = function() {
				if (!this.scrolling) {
					for (var t = 0, e = this.childWidgets.length; e > t; t++) {
						var i = this.childWidgets[t];
						if (i.isEmpty || this.isSetData) {
							var o = this.data[i.whichData];
							this.itemRender && this.itemRender(i.getDOMNode(), o), i.isEmpty = !1
						}
					}
					window.resumeImgLoading && window.resumeImgLoading(), this.fire(new l["default"]("contentloaded", this))
				}
			}, e.prototype.splice = function() {
				Array.prototype.splice.apply(this.data, arguments), this.isSetData = !0, this.loadContent(), this.isSetData = !1
			}, e.prototype.getEvents = function() {
				return t.prototype.getEvents.call(this).concat(["reachend", "contentloaded"])
			}, e
		}(h["default"]);
	e["default"] = f, t.exports = e["default"]
}, function(t, e, i) {
	"use strict";

	function o(t) {
		return t && t.__esModule ? t : {
			"default": t
		}
	}
	function s(t, e) {
		if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
	}
	function r(t, e) {
		if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
		t.prototype = Object.create(e && e.prototype, {
			constructor: {
				value: t,
				enumerable: !1,
				writable: !0,
				configurable: !0
			}
		}), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e)
	}
	Object.defineProperty(e, "__esModule", {
		value: !0
	});
	var n = i(1),
		h = o(n),
		a = i(3),
		l = o(a),
		d = i(2),
		c = o(d),
		f = i(6),
		u = (o(f), function(t) {
			function e(i) {
				s(this, e), t.call(this, i), this._init()
			}
			return r(e, t), e.prototype._init = function() {
				var t = this;
				this.listDom = document.createElement("div"), this.listDom.style.position = "relative", this.listDom.style.width = "100%", this.con.innerHTML = "", this.con.appendChild(this.listDom), this.duration = void 0 !== this.options.cfg.duration ? parseFloat(this.options.cfg.duration) : .3, this.delay = void 0 !== this.options.cfg.delay ? parseFloat(this.options.cfg.delay) : .1, this.easing = this.options.cfg.easing ? this.options.cfg.easing : "ease-out", this.bottomPadding = void 0 !== this.options.cfg.bottom_padding ? parseFloat(this.options.cfg.bottom_padding) : 0, this.visibleRow = void 0 !== this.options.cfg.visible_row ? parseInt(this.options.cfg.visible_row) : 5, this.listDom.style.transition = "transform " + this.duration + "s " + this.easing, this.listDom.addEventListener("transitionend", function(e) {
					e.target === t.listDom && t.fire(new c["default"]("scrollend", t))
				}), this.getWidgetRect(), this.align = this.rect.height / 2, this.offset = 0, this._reset()
			}, e.prototype._reset = function() {
				this.lastWidgetRow = 0, this.lastWidgetCol = 0, this.lastWidgetCenter = 0, this.listHeight = 0, this.childrenArr = [], this.childWidgets = [], this.childItems = [], this.focusPos = {
					row: 0,
					col: 0
				}
			}, e.prototype.setData = function(t, e) {
				var i = this;
				if (this.isSetData = !0, 0 == this.childItems.length) return this.listDom.innerHTML = "", this._reset(), this.dataIndex = void 0 !== e ? e : 0, this.data = [].concat(t), void this._renderChildren();
				for (var o = !1, s = 0; s < this.childItems.length; s++) {
					var r = this.childItems[s];
					r.con && r.visible && (r.con.style.transform = "scale3d(0.3,0.3,0.3)", o || (o = !0, r.con.addEventListener("transitionend", function(o) {
						i.listDom.innerHTML = "", i._reset(), i.dataIndex = void 0 !== e ? e : 0, i.data = [].concat(t), i._renderChildren()
					})))
				}
			}, e.prototype.addData = function(t) {
				this.data = this.data.concat(t), this._renderChildren()
			}, e.prototype.setItemRender = function(t) {
				this.itemRender = t
			}, e.prototype._renderChildren = function() {
				var t = this;
				if (this.data && this.itemRender) {
					this.isSetData && (this.listDom.style.visibility = "hidden");
					for (var e = function(e) {
							var i = t.data[e],
								o = t.itemRender(i);
							if ("string" == typeof o) {
								var s = t.parseDom(o);
								if (s.length > 1) return console.error("[FocusEngine_Error]Grille组件的itemRender返回的字符串必须是可解析成一个dom对象。"), "continue";
								o = s[0]
							}
							var r = o.querySelector(".grille-lazyload");
							if (r && o.removeChild(r), t.listDom.appendChild(o), !o.getAttribute("data-role")) return t.childItems.push(o), "continue";
							var n = h["default"].createWidget(o);
							t.addChildWidget(n), t.childItems.push(n), n.data = i, n.index = e, n.lazyDom = r, n.getWidgetRectAsync(function(i) {
								if (n.oriOffset = i.centerY - t.rect.top - t.offset, t.listHeight < i.bottom - t.rect.top - t.offset + t.bottomPadding && (t.listHeight = i.bottom - t.rect.top - t.offset + t.bottomPadding), t.lastWidgetCenter ? i.centerY - t.offset === t.lastWidgetCenter ? (n.row = t.lastWidgetRow, t.lastWidgetCol++, n.col = t.lastWidgetCol, t.childrenArr[t.lastWidgetRow].push(n)) : i.centerY - t.offset > t.lastWidgetCenter && (t.lastWidgetRow++, n.row = t.lastWidgetRow, t.lastWidgetCol = 0, n.col = t.lastWidgetCol, t.lastWidgetCenter = i.centerY - t.offset, t.childrenArr[t.lastWidgetRow] = [n]) : (n.row = t.lastWidgetRow, n.col = t.lastWidgetCol, t.lastWidgetCenter = i.centerY, t.childrenArr[t.lastWidgetRow] = [n]), n.row <= t.visibleRow && (n.visible = !0, n.con.style.transition = "transform " + .8 * t.duration + "s " + t.easing), e === t.data.length - 1 && (t.focused && t.childItems[t.dataIndex].focus(), t.isSetData)) {
									t.listDom.style.visibility = "visible";
									var o = t.childItems[t.dataIndex];
									t.loadContent(), t._doScroll(o), t.setCachedChildWidget(o)
								}
							})
						}, i = this.childItems.length; i < this.data.length; i++) {
						e(i)
					}
				}
			}, e.prototype.focusDefault = function(e) {
				t.prototype.focusDefault.call(this, e), e.target !== this && (this.isSetData || (this.dataIndex = e.target.index, this._doScroll(e.target)))
			}, e.prototype._doScroll = function(t) {
				var e = this;
				if (this.focusPos.row = t.row, this.focusPos.col = t.col, !(this.listHeight < this.rect.height)) {
					var i = this.align - t.oriOffset;
					if (i > 0 && (i = 0), this.listHeight - t.oriOffset < this.rect.height - this.align && (i = this.rect.height - this.listHeight), void 0 !== t.data.align && (i = this.align - t.oriOffset), this.offset !== i || this.isSetData) if (this.isSetData) this.listDom.style.transition = "", this.listDom.style.transform = "translateY(" + (i + this.rect.height) + "px)", this.offset = i + this.rect.height, setTimeout(function() {
						e.listDom.style.transition = "transform " + e.duration + "s " + e.easing, e.listDom.style.transform = "translateY(" + i + "px)";
						var t = -e.rect.height / 3;
						e.offset = i, !e.isScrolling && e.fire(new c["default"]("scrollstart", e, {
							des: t
						})), e.isSetData = !1
					}, 300);
					else {
						this.listDom.style.transition = "transform " + this.duration + "s " + this.easing, this.listDom.style.transform = "translateY(" + i + "px)";
						var o = i - this.offset;
						this.offset = i, !this.isScrolling && this.fire(new c["default"]("scrollstart", this, {
							des: o
						}))
					}
				}
			}, e.prototype.keydownDefault = function(t) {
				var e = this.focusPos.row,
					i = this.focusPos.col;
				if (t.keyCode === c["default"].VK_UP && e > 0 && (e--, i >= this.childrenArr[e].length && (i = this.childrenArr[e].length - 1), t.preventDefault()), t.keyCode === c["default"].VK_DOWN && e == this.lastWidgetRow - 1 && this.fire(new c["default"]("reachend", this)), t.keyCode === c["default"].VK_DOWN && e < this.lastWidgetRow && (e++, i >= this.childrenArr[e].length && (i = this.childrenArr[e].length - 1), t.preventDefault()), t.keyCode === c["default"].VK_LEFT && i > 0 && (i--, t.preventDefault()), t.keyCode === c["default"].VK_RIGHT && i < this.childrenArr[e].length - 1 && (i++, t.preventDefault()), e !== this.focusPos.row || i !== this.focusPos.col) {
					this.focusPos.row = e, this.focusPos.col = i;
					var o = this.childrenArr[e][i];
					o.focus()
				}
			}, e.prototype.scrollstartDefault = function(t) {
				this.isScrolling = !0, window.stopImgLoading && window.stopImgLoading(), clearTimeout(this.loadContentTimeout);
				for (var e = this.childItems[this.dataIndex], i = 0; i < this.childWidgets.length; i++) {
					var o = this.childWidgets[i],
						s = -Math.abs(o.col - e.col) * t.des * this.delay;
					o.con.style.transform = "translateY(" + s + "px)"
				}
			}, e.prototype.scrollendDefault = function(t) {
				var e = this;
				this.isScrolling = !1;
				for (var i = this.childItems[this.dataIndex], o = 0; o < this.childWidgets.length; o++) {
					var s = this.childWidgets[o],
						r = Math.floor(this.visibleRow / 2);
					Math.abs(s.row - i.row) <= r ? (s.con.style.transition = "transform " + .8 * this.duration + "s " + this.easing, s.visible = !0) : s.visible && (s.con.style.transition = "", s.visible = !1), s.con.style.transform = ""
				}
				this.loadContentTimeout = setTimeout(function() {
					e.loadContent()
				}, 500)
			}, e.prototype.loadContent = function() {
				for (var t = 0; t < this.childWidgets.length; t++) {
					var e = this.childWidgets[t];
					e.lazyDom && e.visible && !e.lazyLoaded ? (e.con.appendChild(e.lazyDom), e.lazyLoaded = !0) : e.lazyDom && !e.visible && e.lazyLoaded && (e.con.removeChild(e.lazyDom), e.lazyLoaded = !1)
				}
				window.resumeImgLoading && window.resumeImgLoading(), this.fire(new c["default"]("contentloaded", this))
			}, e.prototype.getEvents = function() {
				return t.prototype.getEvents.call(this).concat(["scrollstart", "scrollend", "contentloaded", "reachend"])
			}, e
		}(l["default"]));
	e["default"] = u, t.exports = e["default"]
}]);



// WEBPACK FOOTER //
// ./src/commonjs/GITV-JD.js